import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Match Criteria', prop: 'match_criteria' },
  { title: 'Matched', prop: 'matched', format: 'bool' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' }
]

const filters = [{
  name: 'Matched',
  prop: 'filters.matched',
  type: 'select',
  enabled: true,
  items: [{
    prop: true,
    title: 'Matched'
  }, {
    prop: false,
    title: 'Not Matched'
  }]
}, {
  name: 'Filter by user',
  prop: 'filters.user_id',
  type: 'autocomplete',
  references: 'admin/users',
  dataHydrator: userEmailHydrator,
  displayProp: 'displayVal',
  referenceProp: 'fullname',
  enabled: true
}]

const defaults = {
  order: [{
    column: 'matched',
    direction: 'asc'
  }, {
    column: 'created_at',
    direction: 'asc'
  }]
}

const BuddyRequests = props => (
  <List
    title='Buddy Requests'
    apiPath='admin/buddy_requests'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    hideCreate
  />
)

export default BuddyRequests
